import React from "react";
import { useNavigate } from "react-router-dom";
import "./homepageswipper.css"; // or homepagevideo.css

const HomePageVideo = () => {
  const navigate = useNavigate();

  return (
    <div className="hero-video-container">
      {/* Background Video */}
      <video
        className="hero-video"
        autoPlay
        loop
        muted
        playsInline
      >
        {/* Replace with your video path */}
        <source src="/assets/homepage/radhekrishna.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay Mask (Theme Aware) */}
      <div className="video-overlay"></div>

      {/* Text Overlay & CTA */}
      <div className="text-overlay-head-video">
        <h1>Pandey Art House</h1>
        <button className="btn" onClick={() => navigate("/category")}>
          View More
        </button>
      </div>
    </div>
  );
};

export default HomePageVideo;